import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18next from './i18n/i18n';
import { ThemeProvider } from './common/theme/ThemeProvider';
import { Layout } from './common/components/Layout';
import { ROUTE_LOGIN, ROUTE_LOGIN_SUCCESS, ROUTE_ROOT } from './constants/routes';
import {
  AuthInitPlaceholder,
  AuthProvider,
  LoginPage,
  LoginSuccessPage,
  useAuth,
} from './features/Auth';

const AppRoutes: React.FC = () => {
  const { authStatus, isLoggedIn } = useAuth();
  const futureConfig = { v7_startTransition: true, v7_relativeSplatPath: true };

  if (authStatus === 'initializing') {
    return <AuthInitPlaceholder />;
  }

  return (
    <I18nextProvider i18n={i18next}>
      <ThemeProvider>
        <BrowserRouter future={futureConfig}>
          <Routes>
            <Route path={ROUTE_LOGIN} element={isLoggedIn ? <Navigate to={ROUTE_ROOT} /> : <LoginPage />} />
            <Route path={ROUTE_LOGIN_SUCCESS} element={<LoginSuccessPage />} />
            <Route
              path="/*"
              element={isLoggedIn ? <Layout /> : <Navigate to={ROUTE_LOGIN} replace />}
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </I18nextProvider>
  );
};

const App: React.FC = () => (
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
);

export default App;
